import React from 'react';
import { isXPSPromotionInstance, PromotionInstance } from '../../models/apis/promotion';
import { FeedInstance } from '../../models/feed';
import { genPCMCode } from '../../utils/spmHelper';

export interface AdConfig {
    width: number,
    height: number,
    spmCode?: string,
    dataSource: Array<FeedInstance | PromotionInstance>,
    children?: any,
}

export const GodBox = (props: AdConfig) => {
    const { dataSource, width, height, spmCode, children } = props;
    const adConfig = dataSource[0];
    if (!adConfig) {
        if (width === 1180) { return null; }
        return <div style={{ height, width }} className="god-box">{children}</div>;
    }
    if (!isXPSPromotionInstance(adConfig)) {
        if (width === 1180) { return null; }
        return <div style={{ height, width }} className="god-box" data-ad-type={adConfig.adType}>{children}</div>;
    }
    return (
        <div data-spm={spmCode} data-w={width}>
            <div
                className="god-box"
                data-w={width}
                data-h={height}
                data-maxreads={adConfig.adData.maxreads}
                data-turn={adConfig.adData.turn}
                data-god-id={adConfig.adData.itemspaceid}
                data-god-ps={adConfig.adData.adps}
                style={{ height, width }}
                data-spm-type="resource"
                data-spm-content={genPCMCode(adConfig)}
                data-spm-stop="nev"
                data-spm-strict="true"
                data-ad-type={adConfig.adType}
            >
                {children}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/AdGod/GodBox.tsx